// extracted by mini-css-extract-plugin
module.exports = {"adjustQuotaInfo":"index_adjustQuotaInfo_3dTd7","contentIcon":"index_contentIcon_3ZiCh","contentText":"index_contentText_1-jf8"};